<main itemscope itemtype="https://schema.org/AboutPage">
  <!-- METADATOS INVISIBLES AEO PARA BÚSQUEDA Y MOTOR DE RESPUESTAS IA -->
  <meta itemprop="name" content="Maestros Rommeliers, Procesos Artesanales y Distinciones — Estancos Distilling Co." />
  <meta itemprop="description" content="Conoce a los Maestros Rommeliers de Estancos Distilling Co., los 5 procesos de destilación artesanal a 2500 msnm y las medallas internacionales obtenidas por Ron Legarda y Whisky Real Audiencia." />

  <!-- BREADCRUMBS SCHEMA.ORG PARA AEO Y SEO -->
  <nav class="breadcrumb-container container" aria-label="Navegación secundaria">
    <ol class="breadcrumb-list" itemscope itemtype="https://schema.org/BreadcrumbList">
      <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <a itemprop="item" href="/">
          <span itemprop="name">Inicio</span>
        </a>
        <meta itemprop="position" content="1" />
      </li>
      <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" aria-current="page">
        <span itemprop="name">Maestría & Herencia</span>
        <meta itemprop="position" content="2" />
      </li>
    </ol>
  </nav>

  <!-- HERO NEOCLÁSICO DE MAESTRÍA -->
  <header class="page-hero">
    <div class="container">
      <div class="hero-crest" aria-hidden="true">
        <span class="crest-symbol">⚜</span>
      </div>
      <span class="hero-subtitle">Excelencia, Sabiduría & Galardones</span>
      <h1 itemprop="headline">Maestría, Alquimia & Distinciones</h1>
      
      <div class="classic-divider" aria-hidden="true">
        <span class="divider-line"></span>
        <span class="divider-diamond">◆</span>
        <span class="divider-line"></span>
      </div>

      <p itemprop="abstract">
        La grandeza de nuestros espirituosos andinos nace de la unión perfecta entre el conocimiento experto de nuestros Maestros Rommeliers, los 5 pilares de destilación a 2500 msnm y el reconocimiento mundial en las competencias más exigentes.
      </p>

      <!-- BARRA DE NAVEGACIÓN RÁPIDA ACCESIBLE -->
      <nav class="quick-nav-bar" aria-label="Secciones clave de maestría">
        <button 
          type="button" 
          class="quick-nav-link" 
          (click)="scrollToSection('maestros-rommeliers', $event)"
          aria-label="Ir a la sección Maestros Rommeliers"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
          </svg>
          <span>Maestros Rommeliers</span>
        </button>

        <button 
          type="button" 
          class="quick-nav-link" 
          (click)="scrollToSection('procesos-destilacion', $event)"
          aria-label="Ir a la sección Procesos de Altura"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
          <span>Procesos de Altura</span>
        </button>

        <button 
          type="button" 
          class="quick-nav-link" 
          (click)="scrollToSection('distinciones-premios', $event)"
          aria-label="Ir a la sección Premios Internacionales"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125v3.375m9 0h3.375c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-3.375m-9 3.75h-3.375A1.125 1.125 0 013 17.625v-1.5c0-.621.504-1.125 1.125-1.125h3.375" />
          </svg>
          <span>Premios Internacionales</span>
        </button>
      </nav>

    </div>
  </header>

  <!-- SECCIÓN 1: MAESTROS ROMMELIERS -->
  <section id="maestros-rommeliers" class="page-section">
    <app-rommelier-card></app-rommelier-card>
  </section>

  <div class="section-gold-divider container" aria-hidden="true">
    <span class="line"></span>
    <span class="ornament">⚜</span>
    <span class="line"></span>
  </div>

  <!-- SECCIÓN 2: PROCESOS DE DESTILACIÓN -->
  <section id="procesos-destilacion" class="page-section">
    <app-procesos></app-procesos>
  </section>

  <div class="section-gold-divider container" aria-hidden="true">
    <span class="line"></span>
    <span class="ornament">⚜</span>
    <span class="line"></span>
  </div>

  <!-- SECCIÓN 3: PREMIOS Y DISTINCIONES -->
  <section id="distinciones-premios" class="page-section">
    <app-premios></app-premios>
  </section>
</main>
